import { useState, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import LocaleSelect from 'components/global/LocaleSelect';
import MyAccount from './myAccount';
import { API_URL } from '../../../environment';
import { headers } from '../../../actions/defaults';
import { signoutUser } from '../../../actions/auths';
import TaxInformation from './TaxInformation';

const Dashboard = props => {
  const [clinicAdminData, setClinicAdminData] = useState({});

  const theme = createTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get(`${API_URL}/clinic_admin/users/me`, headers())
      .then(response => {
        dispatch({
          type: 'FETCH_USER_SUCCESS',
          payload: response,
        });
        setClinicAdminData(response.data);
      })
      .catch(() => {
        props.history.push('/signin_clinic');
      });
  }, []);

  const signOutHandler = () => {
    props.signoutUser();
    props.history.push('/signin_clinic');
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div style={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="absolute">
            <Toolbar sx={{ paddingRight: '24px' }}>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                {clinicAdminData?.clinic?.clinic_name}
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => signOutHandler()}
                size="large"
              >
                <Typography color="inherit" noWrap sx={{ flexGrow: 1 }}>
                  <FormattedMessage defaultMessage="Logout" />
                </Typography>
              </IconButton>
              <LocaleSelect variant="light" />
            </Toolbar>
          </AppBar>
          <main
            style={{
              marginTop: '80px',
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <div />
            <Container
              maxWidth="lg"
              sx={t => ({
                paddingTop: t.spacing(4),
                paddingBottom: t.spacing(4),
              })}
            >
              <Grid container spacing={3}>
                <Grid size={12}>
                  <Paper
                    sx={t => ({
                      padding: t.spacing(2),
                      display: 'flex',
                      overflow: 'auto',
                      flexDirection: 'column',
                    })}
                  >
                    <MyAccount clinicAdminData={clinicAdminData} />
                  </Paper>
                </Grid>
                <Grid size={12}>
                  <Paper
                    sx={t => ({
                      padding: t.spacing(2),
                      display: 'flex',
                      overflow: 'auto',
                      flexDirection: 'column',
                    })}
                  >
                    <TaxInformation clinicAdminData={clinicAdminData} />
                  </Paper>
                </Grid>
              </Grid>
            </Container>
          </main>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

Dashboard.propTypes = {
  signoutUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(
  injectIntl(connect(null, { signoutUser })(Dashboard)),
);
